import React from 'react';
import { ProfilePicture } from '@getro/rombo';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass/styled-components';
import pluralize from 'pluralize';

import InPortco from 'components/organisms/contactCard/inPortco';
import { getContactDisplayName } from 'helpers/getContactDisplayName';
import { toStringLastChange } from '../../../../../services/contacts/postitions';
import { ContactSocialsAndSource } from '../contactSocialsAndSource';

export const ContactAvatar = ({ contact, type, trackLinkedinClick, onLinkedinClick, showEmailDropdown }) => {
  const lastChange = toStringLastChange(contact.primaryActivePosition);

  return (
    <Flex
      sx={{
        columnGap: '16px',
        rowGap: '8px',
      }}
    >
      <Flex flexDirection="column" flexGrow="1" sx={{ gap: '4px' }}>
        <Text
          as="h1"
          fontWeight="600"
          fontSize="18px"
          color="text.dark"
          lineHeight="1.2"
          sx={{
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            display: '-webkit-box',
            '-webkit-line-clamp': '2',
            '-webkit-box-orient': 'vertical',
          }}
        >
          {getContactDisplayName(contact)}
        </Text>
        {contact.linkedinTagline && (
          <Text as="span" fontSize="14px" fontWeight="500">
            {contact.linkedinTagline}
          </Text>
        )}
        {contact.location?.description && (
          <Text fontSize="14px" color="text.subtle">
            {contact.location?.description}
          </Text>
        )}
        {contact.yearsOfExperience && Math.floor(contact.yearsOfExperience) > 0 && (
          <Text fontSize="14px" color="text.subtle">
            {`${Math.floor(contact.yearsOfExperience)} ${pluralize(
              'year',
              Math.floor(contact.yearsOfExperience),
            )} of experience`}
          </Text>
        )}
        {!!lastChange && Math.abs(lastChange) >= 2 && (
          <Text fontSize="14px" fontWeight="medium" color="success">
            {`Last job change ${Math.abs(lastChange)} ${pluralize('year', Math.abs(lastChange))} ago`}
          </Text>
        )}
        {contact.inPortco && (
          <Box pt="4px">
            <InPortco showTooltip={type === 'matches'} />
          </Box>
        )}
        <ContactSocialsAndSource
          showEmailDropdown={showEmailDropdown}
          onLinkedinClick={onLinkedinClick}
          trackLinkedinClick={trackLinkedinClick}
          contact={contact}
        />
      </Flex>

      <Box
        width="48px"
        height="48px"
        flex="0 0 auto"
        sx={{
          position: 'relative',
        }}
      >
        <ProfilePicture
          mb="8px"
          name={getContactDisplayName(contact, 'Getro')}
          imageUrl={contact.profilePicUrl || ''}
        />
      </Box>
    </Flex>
  );
};

ContactAvatar.propTypes = {
  contact: PropTypes.object.isRequired,
  type: PropTypes.oneOf(['default', 'read', 'matches', 'public']),
  trackLinkedinClick: PropTypes.func,
  onLinkedinClick: PropTypes.func,
  showEmailDropdown: PropTypes.bool,
};

ContactAvatar.defaultProps = {
  type: 'default',
  trackLinkedinClick: () => {},
  onLinkedinClick: null,
  showEmailDropdown: true,
};
